import { PageRoutes } from 'debit-card/constants/PageRoutes'
import type { RouteRecordRaw } from 'vue-router'

export const debitCardRoutes: RouteRecordRaw[] = [
  // 404 not found重定向
  {
    path: '/:pathMatch(.*)*',
    redirect: PageRoutes.Home,
  },
  {
    path: PageRoutes.Home,
    component: () => import('debit-card/views/PortalView/PortalView'),
    meta: {
      title: '首页',
    },
  },
  {
    path: PageRoutes.DebitIndex,
    component: () => import('debit-card/views/DebitIndexView/DebitIndexView'),
    meta: {
      title: '信用卡',
    },
  },
  {
    path: PageRoutes.OpenCard,
    component: () => import('debit-card/views/OpenCardView/OpenCardView'),
    meta: {
      title: '开通卡片',
    },
  },
  {
    path: PageRoutes.DebitDetail,
    component: () => import('debit-card/views/CardDetailView/index'),
    meta: {
      title: '卡详情',
    },
  },
  {
    path: PageRoutes.CardApply,
    component: () => import('debit-card/views/CardApplyView/index'),
    meta: {
      title: '申请卡片',
    },
  },
  {
    path: PageRoutes.DebitRight,
    component: () => import('debit-card/views/CardRightView/index'),
    meta: {
      title: '卡权益',
    },
  },
  {
    path: PageRoutes.MyCards,
    component: () => import('debit-card/views/MyCardsView/index'),
    meta: {
      title: '我的卡片',
    },
  },
  {
    path: PageRoutes.BillDetail,
    component: () => import('debit-card/views/BillDetailView/index'),
    meta: {
      title: '交易详情',
    },
  },
  {
    path: PageRoutes.BillList,
    component: () => import('debit-card/views/BillListView/index'),
    meta: {
      title: '交易记录',
    },
  },
  {
    path: PageRoutes.CardPackage,
    component: () => import('debit-card/views/CardPackageView/index'),
    meta: {
      title: '卡包',
    },
  },
  {
    path: PageRoutes.CardManage,
    component: () => import('debit-card/views/CardManageView/index'),
    meta: {
      title: '卡管家',
    },
  },
  {
    path: PageRoutes.CardExpress,
    component: () => import('debit-card/views/CardExpressView/index'),
    meta: {
      title: '查看物流',
    },
  },
  {
    path: PageRoutes.DeleteCardList,
    component: () => import('debit-card/views/CardPackageView/index'),
    meta: {
      title: '已删除卡片列表',
      isHidden: true,
    },
  },
  {
    path: PageRoutes.ConsumptionReport,
    component: () => import('debit-card/views/ConsumptionReportView/index'),
    meta: {
      title: '消费报告',
    },
  },
  {
    path: PageRoutes.CardInfo,
    component: () => import('debit-card/views/CardInfoView/index'),
    meta: {
      title: '卡信息',
    },
  },
  {
    path: PageRoutes.SubCardApply,
    component: () => import('debit-card/views/SubCardApplyView/index'),
    meta: {
      title: '附属卡开卡',
    },
  },
  {
    path: PageRoutes.SendSubCardApply,
    component: () => import('debit-card/views/SubCardApplyView/index'),
    meta: {
      title: '赠送附属卡',
      isSwitch: true,
    },
  },
  {
    path: PageRoutes.SendSubCard,
    component: () => import('debit-card/views/SendSubCardView/index'),
    meta: {
      title: '赠送附属卡',
      isSwitch: true,
    },
  },
  {
    path: PageRoutes.BindCard,
    component: () => import('debit-card/views/BindCardView/index'),
    meta: {
      title: '绑定卡片',
      isSubCard: false,
    },
  },
  {
    path: PageRoutes.BindSubCard,
    component: () => import('debit-card/views/BindCardView/index'),
    meta: {
      title: '绑定卡片',
      isSubCard: true,
    },
  },
  {
    path: PageRoutes.QuickBind,
    component: () => import('debit-card/views/QuickBindView/index'),
    meta: {
      title: '绑定卡片',
    },
  },
  {
    path: PageRoutes.SubCardDetail,
    component: () => import('debit-card/views/SubCardDetailView/index'),
    meta: {
      title: '附属卡',
    },
  },
]
